<template>
  <div class="user-input-listener"></div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  data: () => ({
    scrolling: false
  }),
  created () {
    window.addEventListener('scroll', () => { this.scrolling = true })
    this.$_updateScrollPosition()
  },
  methods: {
    ...mapMutations('animations', [
      'updateScrollPosition'
    ]),
    $_updateScrollPosition () {
      window.requestAnimationFrame(() => {
        if (this.scrolling) {
          this.updateScrollPosition(window.pageYOffset)
          this.scrolling = false
        }
        this.$_updateScrollPosition()
      })
    }
  }
}
</script>

<style>
.user-input-listener {
  display: none !important;
}
</style>
